import { useState, useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { isEqual } from 'lodash';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { STATUS } from 'utils/constants';
import { Token, Meta, TOKEN_SCOPE_TYPE } from 'utils/types';

import tokensTransformer from '../transformers/tokensTransformer';
import c from '../utils/constants';

interface Params {
  keyword?: string;
  emailAddress?: string;
  status?: STATUS;
  source?: any[];
  accountUserId?: string;
  scopes?: TOKEN_SCOPE_TYPE[];
}

interface Result {
  data: Token[];
  meta: Meta;
}

export default function useGetTokens(q: Params = {}) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  const [params, setParams] = useState(q);

  useEffect(() => {
    if (!isEqual(q, params)) {
      setParams(q);
    }
  }, [params, q]);

  return useQuery<Result, Error>({
    queryKey: [c.TOKENS, params],
    queryFn: async () => {
      const api = new Api(args);

      if (params?.keyword) {
        params.keyword = params.keyword.replace('+', '');
      }

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/webhooks/tokens',
            params,
            transformer: tokensTransformer.tokens,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/webhooks/tokens`,
            params,
            transformer: tokensTransformer.tokens,
          },
        }),
      );

      return data;
    },
  });
}
